<style>
	.amort-page {
		padding: 1rem 0;
	}

	.amort-hero {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		gap: 1rem;
		padding: 0.25rem 0 1rem;
		border-bottom: 1px solid rgba(31, 41, 55, 0.12);
		margin-bottom: 1rem;
	}

	.amort-hero__title {
		margin: 0;
		font-size: 1.8rem;
		font-weight: 700;
		color: #1f2937;
	}

	.amort-hero__subtitle {
		margin: 0.25rem 0 0;
		color: #6b7280;
		font-size: 0.95rem;
	}

	.amort-grid {
		display: grid;
		grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.7fr);
		gap: 1rem;
	}

	.amort-card {
		background: #ffffff;
		border: 1px solid #d1d5db;
		border-radius: 18px;
		box-shadow: 0 10px 24px rgba(17, 24, 39, 0.05);
		overflow: hidden;
	}

	.amort-card__header {
		padding: 1rem 1.1rem;
		background: linear-gradient(180deg, #f8f8f8 0%, #eeeeee 100%);
		border-bottom: 1px solid #d9d9d9;
	}

	.amort-card__title {
		margin: 0;
		font-size: 1rem;
		font-weight: 700;
		color: #111827;
	}

	.amort-card__body {
		padding: 1.1rem;
	}

	.amort-helper {
		margin: 0.4rem 0 0;
		color: #5f6368;
		font-size: 0.92rem;
		line-height: 1.45;
	}

	.amort-input-row {
		display: flex;
		gap: 0.75rem;
		align-items: flex-end;
		margin-top: 1rem;
	}

	.amort-field {
		flex: 1 1 auto;
	}

	.amort-input {
		width: 100%;
		height: 48px;
		border: 1px solid #cfd4da;
		border-radius: 12px;
		padding: 0 0.9rem;
		font-size: 1rem;
		outline: none;
		background: #fdfefe;
		transition: border-color 0.15s ease, box-shadow 0.15s ease;
	}

	.amort-input:focus {
		border-color: #6b7280;
		box-shadow: 0 0 0 3px rgba(107, 114, 128, 0.14);
	}

	.amort-button {
		height: 48px;
		min-width: 9rem;
		border-radius: 12px;
		background-color: #005f7f;
		border-color: #005f7f;
		color: #ffffff;
	}

	.amort-button:hover,
	.amort-button:focus {
		background-color: #004c66;
		border-color: #004c66;
		color: #ffffff;
	}

	.amort-summary {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 0.75rem;
		margin-top: 0.95rem;
	}

	.amort-summary__item {
		background: #f8f8f8;
		border: 1px solid #e1e1e1;
		border-radius: 14px;
		padding: 0.85rem 0.9rem;
	}

	.amort-summary__label {
		display: block;
		font-size: 0.78rem;
		text-transform: uppercase;
		letter-spacing: 0.04em;
		color: #6b7280;
		margin-bottom: 0.25rem;
	}

	.amort-summary__value {
		font-size: 1rem;
		font-weight: 700;
		color: #111827;
		word-break: break-word;
	}

	.amort-status {
		margin-top: 1rem;
		padding: 0.85rem 1rem;
		border-radius: 12px;
		font-size: 0.95rem;
		line-height: 1.4;
	}

	.amort-status--error {
		background: #fafafa;
		color: #374151;
		border: 1px solid #d1d5db;
	}

	.amort-status--loading {
		background: #fafafa;
		border: 1px solid #d1d5db;
	}

	.amort-table-card {
		padding: 0;
	}

	.amort-table-wrap {
		padding: 0.3rem 0;
		overflow-x: auto;
	}

	.amort-table-wrap .mat-mdc-table {
		min-width: 760px;
	}

	.amort-table-wrap .mat-mdc-header-row {
		background: #1f2937;
	}

	.amort-table-wrap .mat-mdc-header-cell {
		color: #ffffff;
		font-weight: 700;
		font-size: 0.92rem;
	}

	.amort-table-wrap .mat-mdc-row:nth-child(even) {
		background: #fcfcfc;
	}

	.amort-table-wrap .mat-mdc-cell {
		font-size: 0.92rem;
		color: #111827;
	}

	.amort-table-footer {
		padding: 0.9rem 1.1rem 1.1rem;
		border-top: 1px solid #e5edf2;
	}

	@media (max-width: 900px) {
		.amort-grid {
			grid-template-columns: 1fr;
		}

		.amort-summary {
			grid-template-columns: 1fr;
		}
	}

	@media (max-width: 640px) {
		.amort-hero {
			flex-direction: column;
			align-items: flex-start;
		}

		.amort-input-row {
			flex-direction: column;
			align-items: stretch;
		}

		.amort-button {
			width: 100%;
		}
	}
</style>

<div class="dtf-accountdetails amort-page">
	<div class="dtf-alertpage"></div>

	<div class="container_dashboard">
		<div class="amort-hero">
			<div>
				<h4 class="amort-hero__title">Amortization</h4>
				<p class="amort-hero__subtitle">Look up a loan account and review the amortization schedule in a clean, sortable grid.</p>
			</div>
		</div>

		<div class="amort-grid">
			<div class="amort-card">
				<div class="amort-card__header">
					<h4 class="amort-card__title">Account Lookup</h4>
				</div>
				<div class="amort-card__body">
					<p class="amort-helper">Enter Account number (13 digits) to load amortization details. Numbers only.</p>

					<div class="amort-input-row">
						<div class="amort-field">
							<label for="accountNumber" class="amort-helper" style="display:block; margin-bottom: 0.4rem;">Customer Number or Account Number</label>
							<input
								class="amort-input"
								type="text"
								name="accountNumber"
								id="accountNumber"
								placeholder="e.g., 5002133834 or 5002133834001"
								[(ngModel)]="accountNumber"
								required
								autocomplete="off"
								(keypress)="numberOnly($event)"
								(keyup.enter)="applyFilterInput()">
						</div>
						<button
							type="button"
							class="mbfs-button amort-button"
							[disabled]="!canSearch"
							(click)="applyFilterInput()">
							Continue →
						</button>
					</div>

					<div class="amort-status amort-status--loading" *ngIf="loading">
						Loading amortization records...
					</div>

					<div class="amort-status amort-status--error" *ngIf="errorMessage && !loading">
						{{ errorMessage }}
					</div>
				</div>
			</div>

			<div class="amort-card" *ngIf="submittedValue">
				<div class="amort-card__header">
					<h4 class="amort-card__title">Selected Account Information</h4>
				</div>
				<div class="amort-card__body">
					<div class="amort-summary">
						<div class="amort-summary__item">
							<span class="amort-summary__label">Selected Account Number</span>
							<div class="amort-summary__value">{{ selectedAccount || submittedValue }}</div>
						</div>
						<div class="amort-summary__item">
							<span class="amort-summary__label">Records Loaded</span>
							<div class="amort-summary__value">{{ dataSource.data.length }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="amort-card" *ngIf="dataSource.data.length > 0 && !loading" style="margin-top: 1rem;">
			<div class="amort-card__header">
				<h4 class="amort-card__title">Amortization Details</h4>
			</div>
			<div class="amort-table-wrap">
				<mat-table [dataSource]="dataSource" class="mat-elevation-z0" matSort>
					<ng-container matColumnDef="paymentReceiptDate">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.paymentReceiptDate | date:'MM/dd/yyyy' }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="paymentType">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Payment</mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.paymentType }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="principalAmount">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Principal</mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.principalAmount | currency:'USD':true:'1.2-2' }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="interestAmount">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Interest</mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.interestAmount | currency:'USD':true:'1.2-2' }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="otherFee">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Other Fees</mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.otherFee | currency:'USD':true:'1.2-2' }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="totalPayment">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Payment</mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.totalPayment | currency:'USD':true:'1.2-2' }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="outStandingBalance">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Balance</mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.outStandingBalance | currency:'USD':true:'1.2-2' }}</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
				</mat-table>
			</div>
			<div class="amort-table-footer">
				<mat-paginator [pageSizeOptions]="[50]" [pageSize]="50" showFirstLastButtons></mat-paginator>
			</div>
		</div>
	</div>
</div>
